import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles.css';

async function start() {
  // The mock is a separate chunk that production builds never load.
  if (import.meta.env.VITE_MOCK === '1') {
    const { installMock } = await import('./mock/install.js');
    installMock();
  }
  const root = document.getElementById('root');
  if (!root) throw new Error('#root missing');
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void start();
